import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api, getUser } from "@/lib/api";
import { Clock, Calendar, Search } from "lucide-react";

export default function CourseCatalog() {
  const [courses, setCourses] = useState([]);
  const [enrolledIds, setEnrolledIds] = useState(new Set());
  const [q, setQ] = useState("");
  const user = getUser();

  const load = async () => {
    const c = await api.get("/courses");
    setCourses(c.data);
    if (user?.role === "student") {
      try {
        const e = await api.get("/enrollments/me");
        setEnrolledIds(new Set(e.data.map((x) => x.course_id)));
      } catch { /* ignore */ }
    }
  };
  useEffect(() => { load(); }, []);

  const filtered = courses.filter((c) => c.title.toLowerCase().includes(q.toLowerCase()) || c.category.toLowerCase().includes(q.toLowerCase()));

  return (
    <Layout title="Course Catalog" subtitle="Browse & Enroll">
      <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-xl px-3 py-2 mb-6 max-w-md" data-testid="catalog-search">
        <Search className="w-4 h-4 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} className="bg-transparent outline-none text-sm flex-1" placeholder="Search courses…" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((c) => (
          <div key={c.id} data-testid={`course-card-${c.id}`} className="bg-white border border-slate-200 rounded-2xl overflow-hidden card-hover stagger-in">
            <div className="h-36 bg-gradient-to-br from-blue-500 to-violet-500 relative">
              {c.thumbnail && <img src={c.thumbnail} alt="" className="w-full h-full object-cover" />}
              <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.2em] bg-white/90 text-slate-700 px-2 py-1 rounded-full">{c.category}</span>
            </div>
            <div className="p-5">
              <div className="font-display font-bold text-slate-900 line-clamp-1">{c.title}</div>
              <p className="text-sm text-slate-500 mt-1 line-clamp-2">{c.description}</p>
              <div className="text-xs text-slate-500 mt-3 flex items-center gap-3">
                <span className="inline-flex items-center gap-1"><Clock className="w-3 h-3" />{c.duration}</span>
                <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" />{c.class_timing}</span>
              </div>
              <div className="mt-4 flex gap-2">
                <Link to={`/courses/${c.id}`} data-testid={`view-course-${c.id}`} className="flex-1 text-center text-sm px-3 py-2 rounded-full border border-slate-200 hover:border-blue-500 hover:text-blue-700 transition-colors">
                  View Course
                </Link>
                {enrolledIds.has(c.id) ? (
                  <span className="px-3 py-2 rounded-full bg-emerald-50 text-emerald-700 text-sm">Enrolled</span>
                ) : (
                  <span className="px-3 py-2 rounded-full bg-blue-600 text-white text-sm">Enroll</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Layout>
  );
}
